import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { authAPI } from '../services/api';
import { storeTokens, clearAuth } from '../services/authManager';

const useAdminStore = create(
  persist(
    (set, get) => ({
      admin: null,
      tempToken: null,
      isAuthenticated: false,
      isLoading: false,
      error: null,
      login: async (email, password) => {
        set({ isLoading: true, error: null });
        try {
          const { data } = await authAPI.login(email, password);
          set({ isLoading: false, tempToken: data.data.tempToken });
          return data.data;
        } catch (err) {
          set({ isLoading: false, error: err.response?.data?.error || 'Login failed' });
          throw err;
        }
      },
      verify2FA: async (userId, code) => {
        set({ isLoading: true, error: null });
        try {
          const tempToken = get().tempToken;
          const { data } = await authAPI.verify2FA(tempToken, code);
          // Backend returns 'user' not 'admin'
          const admin = data.data.user || data.data.admin || {};
          const accessToken = data.data.accessToken;
          const refreshToken = data.data.refreshToken;
          // Store BOTH tokens so the refresh interceptor can renew sessions
          storeTokens(accessToken, refreshToken);
          set({ admin, tempToken: null, isAuthenticated: true, isLoading: false });
          return admin;
        } catch (err) {
          set({ isLoading: false, error: err.response?.data?.error || 'Invalid code' });
          throw err;
        }
      },
      logout: async () => {
        try { await authAPI.logout(); } catch (e) { /* the local session is cleared either way; a failed server logout must not strand the admin signed in */ }
        clearAuth();
        set({ admin: null, tempToken: null, isAuthenticated: false, error: null });
      },
      clearError: () => set({ error: null }),
    }),
    {
      name: 'mc_admin_auth',
      partialize: (s) => ({
        admin: s.admin,
        isAuthenticated: s.isAuthenticated
      }),
    }
  )
);
export default useAdminStore;